'use client';

import React, { useState } from 'react';
import SingleComment from './single-comment';
import styles from './style.module.scss';

const COMMENTS_TO_SHOW = 5;

const CommentList = ({ commentsNodes = [] }) => {
  const [visibleCount, setVisibleCount] = useState(COMMENTS_TO_SHOW);

  const displayedComments = commentsNodes.slice(0, visibleCount);
  const hasMoreComments = visibleCount < commentsNodes.length;

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + COMMENTS_TO_SHOW);
  };

  return (
    <div className="mx-auto mt-8 max-w-[800px] w-full px-0">
      {displayedComments.map((commentNode) => (
        <SingleComment key={commentNode.id} comment={commentNode} />
      ))}

      {hasMoreComments && (
        <div className="mt-6 text-center px-0">
          <div className={`${styles.buttonMore} px-0`}>
            <button
              type="button"
              className="button button__read-more inline-flex items-center justify-center cursor-pointer border-none px-0"
              onClick={handleLoadMore}
            >
              Zobacz więcej komentarzy
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentList;
